import {
  Outlet,
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from 'react-router-dom';
import {useEffect, useState} from 'react';
import styles from './analytics.module.scss';
import {DabaProOverviewPage} from './dabaPro/DabaProOverviewPage';
import {DabaAcademyOverviewPage} from './dabaAcademy/DabaAcademyOverviewPage';
import {DabaPowerOverviewPage} from './dabaPower/DabaPower';
import {DabaSimulatorOverviewPage} from './dabaSimulator/DabaSimulatorOverviewPage';
import {WhatWillYouDoOverviewPage} from './whatWillYouDo/WhatWillYouDoOverviewPage';
import {FeedbackDigestPage} from './feedbackDigest/FeedbackDigestPage';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';
import {CheckoutAbandonmentPage} from './checkoutAbandonment/CheckoutAbandonmentPage';

const ANALYTICS_SUBTABS = [
  {key: 'daba-pro', label: 'Daba Pro'},
  {key: 'daba-academy', label: 'Daba Academy'},
  {key: 'daba-power', label: 'Daba Power'},
  {key: 'daba-simulator', label: 'Daba Simulator'},
  {key: 'what-will-you-do', label: 'User Investment Purpose'},
  {key: 'feedback-digest', label: 'Feedback digest'},
  {key: 'checkout-abandonment', label: 'Abandoned checkouts'},
];

const AnalyticsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('daba-pro');
  const {visibleSubTabs, visibleKeys, firstVisible} = useVisibleSubTabs(
    NavTabsEnum.Analytics,
    ANALYTICS_SUBTABS,
  );

  useEffect(() => {
    const path = location.pathname.split('/').pop();
    if (path === 'analytics' || path === '') {
      setActiveTab('daba-pro');
      // If we are at /dashboard/analytics, redirect to /dashboard/analytics/daba-pro
      if (path === 'analytics') {
        navigate('daba-pro', {replace: true});
      }
    } else {
      setActiveTab(path);
    }
  }, [location, navigate]);

  // Redirect away from a sub-tab the admin can't access.
  useEffect(() => {
    if (firstVisible && !visibleKeys.includes(activeTab)) {
      navigate(firstVisible.key, {replace: true});
    }
  }, [firstVisible, visibleKeys, activeTab, navigate]);

  const handleTabChange = tab => {
    setActiveTab(tab);
    navigate(tab);
  };

  return (
    <div className={styles.container}>
      <div className={styles['details-toggler']}>
        {visibleSubTabs.map(tab => (
          <button
            type="button"
            key={tab.key}
            className={activeTab === tab.key ? styles['active-toggle'] : ''}
            onClick={() => handleTabChange(tab.key)}>
            {tab.label}
          </button>
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export const AnalyticsRoutes = () => {
  return (
    <Routes>
      <Route element={<AnalyticsLayout />}>
        <Route index element={<Navigate to="daba-pro" replace />} />
        <Route path="daba-pro" element={<DabaProOverviewPage />} />
        <Route path="daba-academy" element={<DabaAcademyOverviewPage />} />
        <Route path="daba-power" element={<DabaPowerOverviewPage />} />
        <Route path="daba-simulator" element={<DabaSimulatorOverviewPage />} />
        <Route
          path="checkout-abandonment"
          element={<CheckoutAbandonmentPage />}
        />
        <Route
          path="what-will-you-do"
          element={<WhatWillYouDoOverviewPage />}
        />
        <Route path="feedback-digest" element={<FeedbackDigestPage />} />
      </Route>
    </Routes>
  );
};
